export const recalculatePrefs = responses => dispatch => {
  dispatch({
    type: "RECALCULATE_PREFS",
    payload: responses
  });
};
